import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const UPDATE = graphql(`
  mutation updateNewsBanner($id: ID!, $input: UpdateNewsBannerInput!) {
    updateNewsBanner(id: $id, input: $input) {
      ...NewsBannerItem
    }
  }
`);

export function useUpdateNewsBanner() {
  return useMutation(UPDATE, {
    refetchQueries: ['newsBanners', 'newsBanner'],
  });
}
